function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone'; // @namespace Model

var MCPResult = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(MCPResult, _Backbone$Model);

  function MCPResult() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  return MCPResult;
}(Backbone.Model);

export default MCPResult;